define('modules/domain_listing/models/domain_validation',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Model.extend({
    urlRoot: function(){
      return config.apiHost + "/domains/validate?url=" + this.get("url");
    }
  });
});

